export default "__VITE_ASSET__hc6znQc___"